import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Accordion from './Accordion';
import { CategoryPill, categoricalColor, tint } from './Pill';
import { formatDateTime } from '../shared/tenantClock';

// Right-hand sidebar "Timeline" card — the shared dot-and-line stepper
// documented in docs/product/platform/architecture/ui-architecture.md's
// "Detail Page Timeline Sidebar" section. Extracted from QuoteTimeline.js/
// SalesOrderTimeline.js once Sales Order's Picked/Packed milestones moved
// onto the same recorded-history shape as Quote's status steps
// (backend/models/documentMilestone.js) — both callers now build an
// identical `steps` array, so only the domain-specific "which steps exist,
// which is reached/current, where each date comes from" logic stays in
// each caller; this component is pure rendering. Renders through the same
// Accordion card CommercialEntityDetailPage.js's Classification/Addresses/
// Quotes sections use, so it collapses (open by default) and can be
// dismissed for this viewing — dismissal is plain component state, not
// persisted, so it's back next time the page is opened. A step's
// `labelLink` makes its label itself open the detail behind it. A step's
// `by` (who did it) shows on hovering its date, to keep the card uncluttered.
function DocumentTimeline({ steps, title = 'Timeline' }) {
  const [dismissed, setDismissed] = useState(false);
  if (!steps || !steps.length || dismissed) return null;

  return (
    <div className="detail-timeline-card">
      <Accordion title={title} onDismiss={() => setDismissed(true)}>
      {steps.map((step, idx) => {
        const { key, label, labelLink, reached, isCurrent, date, by, link, comment, color } = step;
        const accent = reached ? (color || categoricalColor(label)) : '#c7ccd4';
        return (
          <div key={key} style={{ display: 'flex', gap: 10, position: 'relative', paddingBottom: idx < steps.length - 1 ? 22 : 0 }}>
            {idx < steps.length - 1 && (
              <div style={{ position: 'absolute', left: 5, top: 16, bottom: 0, width: 2, background: reached ? accent : '#e3e7ee' }} />
            )}
            <span
              style={{
                flexShrink: 0,
                width: 12,
                height: 12,
                borderRadius: '50%',
                marginTop: 3,
                zIndex: 1,
                background: reached ? accent : '#e3e7ee',
                boxShadow: isCurrent ? `0 0 0 3px ${tint(accent, 0.82)}` : 'none',
              }}
            />
            <div>
              <div style={{ fontSize: 13, fontWeight: isCurrent ? 700 : 500, color: reached ? '#222' : '#aab2bd' }}>
                {isCurrent ? <CategoryPill value={label} color={color} /> : labelLink ? <Link to={labelLink} className="detail-timeline-label-link">{label}</Link> : label}
              </div>
              <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                {link && <div><Link to={link.to} style={{ color: '#1976d2', textDecoration: 'underline' }}>{link.label}</Link></div>}
                {date ? (
                  <div style={link ? { marginTop: 2 } : undefined} title={by ? `by ${by}` : undefined}>{formatDateTime(date)}</div>
                ) : (
                  !link && (reached ? '' : 'Not yet')
                )}
                {comment && <div style={{ marginTop: 2, color: '#555' }}>{comment}</div>}
              </div>
            </div>
          </div>
        );
      })}
      </Accordion>
    </div>
  );
}

export default DocumentTimeline;
